import {Item} from '../api/dtos/dtos';
import * as React from 'react';
import locales from '../locales';
import {Alert} from 'antd';
import {Link} from 'react-router-dom';
import * as paths from '../paths';
import {renderItemName} from "../item/item-name-renderer";
import {groupNumber, withCurrency} from "../utils/number-utils";


interface Props {
  item: Item;
  onClose?: React.MouseEventHandler<HTMLButtonElement>;
  closable?: boolean;
  style?: React.CSSProperties;
}

class ItemDetailsBox extends React.Component<Props, {}> {

  public render(): React.ReactNode {
    const {item, style} = this.props;
    const content = (
      <table>
        <tbody>
        {this.row(locales.appellation, <Link
          to={paths.viewItemPath(item.id)}>{renderItemName(item)}</Link>)}
        {this.row(locales.inventoryNumber, item.inventoryNumber)}
        {this.row(locales.category, item.category)}
        {this.row(locales.resource, item.resource)}
        {this.row(locales.comment, item.comment)}
        {this.row(locales.item_value, item.value ? withCurrency(groupNumber(item.value)) : '-')}
        </tbody>
      </table>
    );

    return (
      <Alert
        style={{...style}}
        message={content}
        type="info"
        {...this.props}
      />
    );
  }

  private row = (title: string, value?: React.ReactNode): React.ReactNode => {
    if (!value) {
      return null;
    }

    return (
      <tr>
        <td style={{textAlign: 'right', paddingRight: 8, verticalAlign: 'top'}}><b>{title}</b></td>
        <td>{value}</td>
      </tr>
    );
  };

}

export default ItemDetailsBox;


// WEBPACK FOOTER //
// ./src/checklist/ItemDetailsBox.tsx